import { TranslateService } from '@ngx-translate/core';

import { KpiType } from '../../coaching-insight/insight-widget/model/kpi-type.model';
import { AxisDataAxisPath } from '../../scorecard-mi2/chart/axis-data-axis-path';
import { TrendDialogMode } from '../../scorecard-mi2/trend-dialog/model/trend-dialog-mode.model';
import { epicDependencies } from '../../store';
import { rect } from '../constants/trend-chart-rect-config';
import { CoachingTrendData } from '../models/coaching-trend-data.model';
import { WpCoachingCard } from '../models/wp-coaching-card.model';
import { TranslationKeyMap } from '../my-coaching-card.i18n';

import { getLeftTicks } from './get-left-ticks.function';
import { getLegends } from './get-legends.function';
import { createPathPoints } from './get-oa-trend-data-set.function';

export function getWpTrendDataSet(
    wpCoachingCard: WpCoachingCard,
    kpiTypeId?: KpiType,
): CoachingTrendData {
    const translateService =
        epicDependencies.injector.get<TranslateService>(TranslateService);

    const keyText =
        kpiTypeId === KpiType.WINNING_PERCENTAGE
            ? TranslationKeyMap._10094_WINNING__
            : TranslationKeyMap._11080_FRONT_LINE_WINNING__;

    const trendTitleKey =
        kpiTypeId === KpiType.WINNING_PERCENTAGE
            ? TranslationKeyMap._10100_WINNING__TREND
            : TranslationKeyMap._11168_FLWP_TREND;

    const yAxisTitleKey =
        kpiTypeId === KpiType.WINNING_PERCENTAGE
            ? TranslationKeyMap._10101_WINNING__SCORE
            : TranslationKeyMap._11167_FLWP_SCORE;

    const key = translateService.instant(keyText);
    const trendTitle = translateService.instant(trendTitleKey);
    const yAxisTitle = translateService.instant(yAxisTitleKey);

    const points = createPathPoints(
        wpCoachingCard.trend,
        wpCoachingCard.winningThresholdColour,
        key,
    );

    const paths: AxisDataAxisPath[] = [{ key, points }];

    const leftTicks = getLeftTicks();
    const legends = getLegends(paths);

    return {
        mode: TrendDialogMode.MI2,
        showYAxisLabel2: false,
        leftTicks,
        rightTicks: [],
        paths,
        legends,
        rect,
        trendTitle,
        yAxisTitle,
    };
}
